import { render, staticRenderFns } from "./OTPForm.vue?vue&type=template&id=fd134a7a&scoped=true&"
import script from "./OTPForm.vue?vue&type=script&lang=ts&"
export * from "./OTPForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd134a7a",
  null
  
)

export default component.exports